// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_dn-b";
export var colorBlue = "_dn-8";
export var colorDot = "_dn-0";
export var colorDotLarge = "_dn-2";
export var colorDotSmall = "_dn-1";
export var colorGreen = "_dn-7";
export var colorGrey = "_dn-3";
export var colorOrange = "_dn-5";
export var colorPink = "_dn-a";
export var colorPurple = "_dn-9";
export var colorRed = "_dn-4";
export var colorYellow = "_dn-6";